<template>
      <v-container>
        <h2>
          Automation page
        </h2>
        <AutoConfigTables/>
      </v-container>
</template>

<script>
import AutoConfigTables from "../components/autoConfigTables.vue";

export default {
  name: 'Automation',
  props: ["text"],
  components: { AutoConfigTables }
}
</script>
